import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { useDispatch, useSelector } from 'react-redux';

import smartSearchBtnIcon from '../assets/images/Search.svg';
import closeIcon from '../assets/images/CloseIcon.svg';
import smartStarIcon from '../assets/images/smart-stars.svg';
import accordingArrow from '../assets/images/rateExpIcon.svg';
import arrowIcon from '../assets/images/blueArrowIcon.svg'
import tipsSvg from '../assets/images/tips.svg';
import arrow from '../assets/images/black_arrow.svg';
import smartSuggestionIcon from '../assets/images/smart_suggestion.svg';
import clockIcon from '../assets/images/clockIcon.svg';

import MainWrapper from '../components/Wrappers/MainWrapper';
import ModalsWrapper from '../components/Wrappers/ModalsWrapper';
import GenerateButton from '../components/buttons/GenerateButton';
import { useFetchFonts, useFetchFontsWithMd5Hash } from '../services/fontListService';
import { useGenerateImages } from '../services/imageService';
import CardLoader from '../components/Loaders/CardLoader';
import LineLoader from '../components/Loaders/LineLoader';
import FontError from '../components/errors/FontError';
import GenerateVisualError from '../components/errors/GenerateVisualError';
import { setPrompt, setRecommendedPrompt } from '../redux/promptSlice';
import ImageModal from '../../src/components/Modals/ImageModal';
import { reandomFontPicker } from '../utils/helpers';
import NpsFeedback from '../components/Modals/NpsFeedback';
import ServerBusyError from '../components/errors/ServerBusyError';
import SomethingWentWrongError from '../components/errors/SomethingWentWrongError';
import { useIncrementalPrompting } from '../services/incrementalPromptingService';
import ReactGA from "react-ga4";
import { OnBoardingStep1, OnBoardingStep2, OnBoardingStep3, OnBoardingStep4, OnBoardingStep5, OnBoardingStep6 } from '../components/onboarding/Onboarding';
import onboardingImage from '../assets/images/Carousel1.jpeg';
import SomethingWentWrongFontError from '../components/errors/SomethingWentWrongFontError';
import { setClearImageDiscription } from '../redux/uploadImageSlice';
import { setRecommendedFontListFromMd5 } from '../redux/fontListSlice';
import LimitError from '../components/errors/LimitError';
import { setPromptBoxFocus, setPromptBoxHeightRedux } from '../redux/toasterSlice';
import { useUpdateUserData, useUserData } from '../services/userDataService';
import { CloseIconSvg } from '../components/ui/Svgs';
import TipsForBestResults from '../components/ui/TipsForBestResults';
import { setIsTipsForBestResults } from '../redux/onBoardingSlice';
import axios from 'axios';
import { setAutoCompletePrompts } from '../redux/promptSuggestion';
import { usePromptSuggestion } from '../services/promptSuggestionService';
import TermandConditions from '../components/Modals/TermandConditions';
import { useNavigate, useParams } from 'react-router-dom';
import { setCheckTermsAndConditions, setTermsAndConditions } from '../redux/authSlice';
import { setIsVisualizePageVisible } from '../redux/createImageSlice';


const Tooltip = ({ id, place, content }) => (
    <ReactTooltip id={id} place={place} content={content} style={{
        backgroundColor: '#1E242C',
        borderRadius: '8px',
        color: '#FFFFFF',
        fontSize: '13px',
        lineHeight: '16px',
        zIndex: '9999',
    }} />
);

const CreateImages = () => {
    const containerRef = useRef(null);
    const onboardingStep4ref = useRef(null);
    const parentRef = useRef(null);
    const navigate = useNavigate();

    const { urlMd5, urlPrompt, '*': fontFamilyUrl } = useParams();
    const urlParams = new URLSearchParams(window.location.search);

    const dispatch = useDispatch();
    const { fetchFonts } = useFetchFonts();
    const generateImages = useGenerateImages();
    const { fetchFontsWithMd5 } = useFetchFontsWithMd5Hash();
    const incrementalPrompting = useIncrementalPrompting()
    const updateUserData = useUpdateUserData();
    const getUserData = useUserData()
    const { fetchPromptSuggestions, fetchAutoCompletePrompts, fetchRecentlyUsedPrompts } = usePromptSuggestion()


    const { prompt, originalUserPrompt } = useSelector((state) => state.prompt);
    const { isFontLoading, isEditFontLoading, isFontError, errorFontListMessage, recommendedFontList, recommendedFontListFromMd5 } = useSelector((state) => state.fontList);
    const { isImageLoading, isImageError, generatedImages, errorImageMessage, lastPayload } = useSelector((state) => state.createImage);
    const { totalDocuments, pastCreationData } = useSelector((state) => state.pastCreation);
    const { name, email, userData, openTermsAndConditions } = useSelector((state) => state.auth);
    const { message, promptBoxFocus } = useSelector((state) => state.toaster);
    const { onBoardingSteps, isTipsForBestResults } = useSelector((state) => state.onBoarding);
    const { uploadImageLoading, uploadImageErrorMessage } = useSelector((state) => state.uploadImage);
    const { image_description } = useSelector((state) => state.uploadImage);
    const { autoCompletePrompts, promptSuggestionList, recentlyUsedPrompts } = useSelector((state) => state.promptSuggestion);

    const isOnBoarding = !userData?.onboardingCheck && userData?.termsAndConditions

    const [openNpsFeedback, setOpenNpsFeedback] = useState(false)
    const [isTextareaFocused, setIsTextareaFocused] = useState(false);
    const [promptBoxHeight, setPromptBoxHeight] = useState(0);
    const [imageModalWidth, setImageModalWidth] = useState(0);
    const [cardLoaderWidth, setCardLoaderWidth] = useState(0);

    const disableGenerateButton = useMemo(() =>
        prompt.trim().length <= 0 ||
        prompt === generatedImages[0]?.prompt ||
        isImageLoading,
        [prompt, generatedImages, isImageLoading]
    );

    const generateImageHandler = async () => {
        const match = prompt.match(/<([^>]+)>/);
        const md5Pattern = /[a-f0-9]{32}/i;
        const md5Match = match !== null && match[1]?.match(md5Pattern);
        let promptId = "new"
        let font
        fetchRecentlyUsedPrompts()

        if (match && match[1].toUpperCase().includes('IT')) {
            incrementalPrompting(prompt, generatedImages[0]);
        } else {
            try {
                if (md5Match) {
                    const md5hash = md5Match[0];
                    font = await fetchFontsWithMd5(md5hash);
                } else {
                    font = await fetchFonts(prompt);
                }

                fetchPromptSuggestions(prompt)

                if (!isFontLoading && !font) return
                if (recommendedFontListFromMd5?.length > 0) {
                    await generateImages(promptId, prompt, recommendedFontListFromMd5[0]);
                } else {
                    fetchPromptSuggestions(prompt)
                    await generateImages(promptId, prompt, font);
                }


                ReactGA.gtag('event', 'generate_image', {
                    action: 'Image generation from current user session',
                    label: 'Image generation from current user session'
                });

            } catch (error) {
                console.error("Error during font fetching or image generation:", error);
            }
        }

        dispatch(setClearImageDiscription())

        if (pastCreationData <= 3 && userData?.Npsfeedback === 0) {
            getUserData()
        }
    };

    const generateImageBySuggestionPrompt = async (suggestedPrompt) => {
        dispatch(setPrompt(suggestedPrompt))
        let promptId = "new"
        let font

        try {
            font = await fetchFonts(suggestedPrompt);
            if (!isFontLoading && !font) return

            if (recommendedFontListFromMd5?.length > 0) {
                await generateImages(promptId, suggestedPrompt, recommendedFontListFromMd5[0]);
            } else {
                fetchPromptSuggestions(prompt)
                await generateImages(promptId, suggestedPrompt, font);
            }

            ReactGA.gtag('event', 'gen_img_from_suggested_prompt', {
                action: 'Image generation from suggested prompt',
                label: 'Image generation from suggested prompt',
            });

        } catch (error) {
            console.error("Error during font fetching or image generation:", error);
        }

        dispatch(setClearImageDiscription())

        if (pastCreationData <= 3 && userData?.Npsfeedback === 0) {
            getUserData()
        }
    };

    const generateFontVisualsHandler = async (font) => {
        let magicPromptForImageUpload = image_description?.magic_prompt
        let uploadedImageLink = image_description?.uploadedImage
        const lastImage = generatedImages[generatedImages.length - 1];
        const promptId = lastImage?.promptId;
        const prompt = lastImage?.prompt;

        if (image_description?.length === 0) {
            await generateImages(promptId, prompt, font);
        } else {
            await generateImages(promptId, prompt, font, magicPromptForImageUpload, uploadedImageLink);
        }

        ReactGA.gtag('event', 'see_in_context', {
            action: `Image generation using ${font?.font_name} font`,
            label: `Image generation using ${font?.font_name} font`
        });

        if (pastCreationData <= 3 && userData?.Npsfeedback === 0) {
            getUserData()
        }
    };

    const generateImageHandleTandCAccept = async () => {
        let promptId = "new"
        let generatedImage;
        const fontNameFromParams = urlParams.get('fontName');

        let fonts = {
            md5: urlMd5,
            font_name: fontNameFromParams,
            family_url: fontFamilyUrl || "",
            foundry_name: '',
        };

        let semanticFont = {
            md5: recommendedFontList[0]?.md5,
            font_name: recommendedFontList[0]?.font_name,
            family_url: recommendedFontList[0]?.family_url || "",
            foundry_name: '',
        };

        if (promptSuggestionList?.length > 0 && promptSuggestionList[0] !== "Good Prompt") {
            dispatch(setPrompt(promptSuggestionList[0]));
            generatedImage = await generateImages(promptId, promptSuggestionList[0], (fontNameFromParams === null || fontNameFromParams === "null") ? semanticFont : fonts);
        } else {
            dispatch(setPrompt(urlPrompt));
            generatedImage = await generateImages(promptId, urlPrompt, (fontNameFromParams === null || fontNameFromParams === "null") ? semanticFont : fonts);
        }
        if (generatedImage?.status === 200) {
            ReactGA.gtag('event', 'generate_image_from_enterprise_completed', {
                action: 'Image generation through redirection from enterprise',
                label: 'Image generation through redirection from enterprise'
            });
        }
    }

    // Render Functions
    const renderFontsList = (recommendedFontList) => {
        return recommendedFontList?.map((font, index) => {
            const isGenerated = generatedImages?.some(image => image.fontFamily === font.font_name);

            const isGeneratingImage = lastPayload?.font_id === font?.md5;

            return (
                <div
                    key={index}
                    className={`px-[16px] py-[16px] flex justify-between items-center gap-[8px] border-b group ${isGenerated || isGeneratingImage ? 'bg-pink-light' : ''
                        }`}
                >
                    <div className='max-w-[200px] h-[30px] flex'>
                        <img
                            src={`https://sig.monotype.com/render/21/font/${font?.md5}?rt=${font?.font_name}&rs=30&w=452&h=10&tp=0&fg=000000&bg=FFFFFF&t=0&sc=2`}
                            alt=""
                            className="font-image w-[350px] object-fit"
                        />
                    </div>
                    {
                        isGeneratingImage && isImageLoading && onBoardingSteps !== 4 ?
                            <button className={`w-[145px] h-[20px] p-[8px] flexCenter gap-[2px]  text-pink-dark font-[500] rounded-[8px] }`}>
                                <span className='text-[13px] font-helveticaText-Medium leading-[16px]'>Generating...</span>
                            </button>
                            :
                            <div className={` ${onBoardingSteps === 4 && index === 0 ? 'group-hover:flex ' : 'hidden'} group-hover:flex gap-[8px]`}>
                                <button
                                    onClick={() => {
                                        generateFontVisualsHandler(font);
                                        (promptSuggestionList?.length === 0 && fetchPromptSuggestions(prompt))
                                    }}
                                    disabled={isImageLoading || !generatedImages.length}
                                    className={`w-[145px] h-[30px] p-[8px] flexCenter gap-[2px] ${isGenerated ? 'hover:bg-white' : 'hover:bg-pink-light'} text-pink-dark font-[500] rounded-[8px] ${((isImageLoading || !generatedImages.length) && onBoardingSteps !== 4) && 'cursor-not-allowed opacity-[50%]'
                                        }`}
                                >
                                    <img className='h-[16px] w-[16px]' src={smartStarIcon} alt="smart search icon" />
                                    <span className='text-[13px] font-helveticaText-Medium leading-[16px]'>See in context</span>
                                </button>
                            </div>
                    }

                </div>
            );
        });
    };

    // render generated images
    const renderGeneratedImages = useMemo(
        () =>
            generatedImages?.map((image, index) => (
                <ImageModal
                    key={index}
                    imageData={image}
                    generateFontVisualsHandler={generateFontVisualsHandler}
                    containerRef={containerRef}
                    setImageModalWidth={setImageModalWidth}
                />
            )),
        [generatedImages]
    );

    // Tooltip Content
    const tooltipContent = useMemo(() => {
        if (prompt.trim().length <= 0 && !isImageLoading) return 'Please enter a prompt to generate visuals';
        if (prompt === generatedImages[0]?.prompt && !isImageLoading) return 'Edit prompt to generate visuals';
        if (isImageLoading) return 'Generating visual...';
        return 'Generate a new visual';
    }, [prompt, generatedImages, isImageLoading]);

    const buttonRef = useRef(null);
    const [buttonPosition, setButtonPosition] = useState(null);

    useEffect(() => {
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setButtonPosition({
                top: rect.top,
                left: rect.left,
                width: rect.width,
                height: rect.height,
            });
        }
    }, [isOnBoarding, onBoardingSteps]);

    const textareaRef = useRef(null);
    useEffect(() => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = "24px";
            textarea.style.overflowY = "hidden";
            textarea.style.height = `${Math.min(textarea.scrollHeight, 108)}px`;

            if (textarea.scrollHeight > 106) {
                textarea.style.overflowY = "auto";
            }
        }

    }, [prompt]);

    const handleTextareaBlur = () => {
        setTimeout(() => {
            setIsTextareaFocused(false);
            dispatch(setPromptBoxFocus(false))
        }, 200);
    };


    useEffect(() => {
        if (!parentRef.current) return;

        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                setPromptBoxHeight(entry.contentRect.height);
                dispatch(setPromptBoxHeightRedux(entry.contentRect.height))
            }
        });

        resizeObserver.observe(parentRef.current);

        return () => resizeObserver.disconnect();
    }, []);

    const updateUserDataHandler = async (isChecked) => {
        const params = {
            email: email,
            username: name,
            showTipsForBestResultsBar: isChecked,
            termsAndConditions: isChecked,
            onboardingCheck: false,
            globalUserId: urlParams.get('utm_campaign')
        }
        await updateUserData(params)
    }

    const updateShowTipsForBestResultsBar = async () => {
        const params = {
            email: email,
            username: name,
            showTipsForBestResultsBar: false,
        }
        await updateUserData(params)
    }

    useEffect(() => {
        if (generatedImages.length >= 2) {
            window.triggerSurvey(name, email);
        }
    }, [generatedImages, name, email])

    const prompts = [
        "Create a minimalist visual identity for a luxury skincare brand, featuring serif fonts with elegant typography.",
        "A vinyl record store named “Tunes”, located on a busy main road in downtown.",
        "Design a bold and vibrant logo for a youth-centric streetwear brand with handwritten or graffiti-style fonts."
    ];

    const [placeholder, setPlaceholder] = useState(prompts[0]);
    const [isFading, setIsFading] = useState(false);

    // prompt box place holder animation
    useEffect(() => {
        let index = 0;
        if (prompt.length > 0) return;
        const interval = setInterval(() => {
            setIsFading(true);

            setTimeout(() => {
                index = (index + 1) % prompts.length;
                setPlaceholder(prompts[index]);
                setIsFading(false);
            }, 700);

        }, 4000);

        return () => clearInterval(interval);
    }, [prompt]);


    const fetchSuggestionsInputBox = async () => {
        try {
            const response = await fetchAutoCompletePrompts(prompt);

            if (response.data?.data) {
                const suggestions = Object.entries(response.data.data)
                    .filter(([key]) => key.startsWith('Suggestion'))
                    .map(([, value]) => value);

                dispatch(setAutoCompletePrompts(suggestions));
            }
        } catch (error) {
            console.error("Error fetching suggestions:", error);
        }
    };

    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }

        const timer = setTimeout(fetchSuggestionsInputBox, 300);
        return () => clearTimeout(timer);
    }, [prompt]);

    const getHighlightedMatch = (suggestion, inputPrompt) => {
        if (!inputPrompt) {
            return `<span style="color: #1E242C; font-weight: bold">${suggestion}</span>`;
        }

        const escapedPrompt = inputPrompt.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escape special chars
        const regex = new RegExp(`(${escapedPrompt})`, 'i');
        const parts = suggestion.split(regex);

        return parts
            .map(part =>
                part.toLowerCase() === inputPrompt.toLowerCase()
                    ? `<span style="color: #667488;">${part}</span>`
                    : `<span style="color: #1E242C; font-weight: bold">${part}</span>`
            )
            .join('');
    };

    const isPromptEmpty = prompt.length === 0;
    const hasGoodPrompt = autoCompletePrompts.length === 0;

    const shouldShowBox = (document.activeElement === textareaRef.current || promptBoxFocus) && (isPromptEmpty || (!isPromptEmpty && !hasGoodPrompt));

    if (isFontLoading || uploadImageLoading) return <LineLoader />;
    if (isImageError && errorImageMessage.includes("explicit content")) return <FontError title="This doesn&apos;t agree with our community guidelines" subtitle="Your input was blocked due to potential inappropriate content. Please revise it and try again" />
    if (isFontError || uploadImageErrorMessage || errorFontListMessage === "Failed to fetch fonts from md5") return <SomethingWentWrongFontError />
    if ((!isFontLoading || !isEditFontLoading) && recommendedFontList.length === 0 && recommendedFontListFromMd5.length !== 0) return <FontError title="Just a little bit more!" subtitle="Your prompt needs a little bit more details to create an amazing font visual. Please edit and try again." />
    if (isImageError && errorImageMessage.includes("The server is currently busy. Please try again in some time." || "no control image")) return <ServerBusyError />
    if (isImageError && errorImageMessage.includes("Something went wrong")) return <SomethingWentWrongError />
    if (isImageError && errorImageMessage.includes("You have reached the limit of generating 100 images for today.")) return <LimitError />

    return (
        <MainWrapper className='relative hidden-scrollbar'>
            {isOnBoarding && <div className='fixed inset-0 bg-black/80 bg-opacity-50 z-20 h-full w-full'></div>}
            {isOnBoarding && onBoardingSteps === 1 && <OnBoardingStep1 />}

            <div className='h-[calc(100vh-160px)] overflow-hidden'>
                <div className=' flex '>
                    {/* FONT SECTION */}
                    <div className={`h-full ${isOnBoarding && (onBoardingSteps === 3 || onBoardingSteps === 4) && 'z-30 bg-white'}`}>
                        {recommendedFontListFromMd5?.length > 0 && <div className='h-fit min-w-[400px] border-r'>
                            <div className="h-[48px] p-[16px] bg-[#F9FAFB] small-texts flex items-center justify-between border-y">
                                <h3 className='font-helveticaText-Bold font-[700] leading-[16px] '>The font you picked</h3>
                            </div>
                            {renderFontsList(recommendedFontListFromMd5)}
                        </div>}
                        <div className='h-full min-w-[400px] border-r '>
                            <div className="h-[48px] p-[16px] bg-[#F9FAFB] small-texts flex items-center justify-between border-y">
                                <h3 className='font-helveticaText-Bold font-[700] leading-[16px] '>{recommendedFontListFromMd5?.length > 0 ? "Other Recommended fonts" : "Recommended fonts"}</h3>
                                <span className='text-secondary leading-[16px]'>
                                    {recommendedFontList.filter(font =>
                                        !recommendedFontListFromMd5.some(excludedFont => excludedFont.md5 === font.md5)
                                    ).length} styles
                                </span>
                            </div>
                            <div style={{ paddingBottom: `${promptBoxHeight - 48}px` }} className={`${recommendedFontListFromMd5.length > 0 ? 'h-[calc(100vh-328px)]' : 'h-[calc(100vh-208px)]'}   overflow-y-scroll`}>
                                {renderFontsList(recommendedFontList.filter(font =>
                                    !recommendedFontListFromMd5.some(excludedFont => excludedFont.md5 === font.md5)
                                ))}
                            </div>
                        </div>
                    </div>

                    {isOnBoarding && onBoardingSteps === 3 && <OnBoardingStep3 />}
                    {isOnBoarding && onBoardingSteps === 4 && <OnBoardingStep4 />}
                    {isOnBoarding && onBoardingSteps === 6 && <OnBoardingStep6 />}

                    {/* IMAGE SECTION */}
                    <div className='w-[calc(100%-400px)]'>
                        <div className=' h-[48px] p-[16px] bg-[#F9FAFB] small-texts flex justify-between border-y'>
                            <h3 className='font-helveticaText-Bold font-[700] leading-[16px]'>Font inspirations</h3>
                            <div className="w-fit flex items-center justify-center gap-[8px] text-secondary leading-[16px]">
                                <span>{generatedImages.length} images</span>
                            </div>
                        </div>
                        <div className={`h-[calc(100vh-200px)]  w-full  px-[16px] pt-[16px] ${(isOnBoarding && onBoardingSteps === 5) ? '' : 'overflow-y-scroll'}  `}
                            style={{ paddingBottom: `${promptBoxHeight - 20}px` }}
                        >
                            <div ref={onboardingStep4ref} className={`relative grid lg:grid-cols-2 xl:grid-cols-3 gap-3 object-cover ${isOnBoarding && !isImageLoading && onBoardingSteps === 5 && 'z-50'}`}>
                                {isImageLoading && onBoardingSteps !== 5 && <CardLoader setCardLoaderWidth={setCardLoaderWidth} />}
                                {isImageError && <GenerateVisualError />}
                                {onBoardingSteps !== 5 && renderGeneratedImages}
                                {/* {isOnBoarding && onBoardingSteps === 4 && <OnBoardingStep4 />} */}
                                {isOnBoarding && onBoardingSteps === 5 &&
                                    <div className='z-[999] relative'  >
                                        <OnBoardingStep5 imageModalWidth={imageModalWidth || cardLoaderWidth} />
                                        {/* <img src={onboardingImage} alt="" /> */}
                                        {isImageLoading ? <img src={onboardingImage} alt="" /> : renderGeneratedImages}
                                    </div>
                                }
                            </div>
                            {((generatedImages?.length === 1 || (generatedImages?.length === 2 && !isImageLoading)) && promptSuggestionList?.length >= 1 && promptSuggestionList[0] !== "Good Prompt") &&
                                <div className='mt-[20px] flex flex-col gap-[10px]'>
                                    <p className='tuext-[13px] font-helveticaText-Bold'>Want more vibrant images? Try these related to your prompt</p>
                                    {
                                        promptSuggestionList?.slice(1, 3).map((suggestion, index) => (
                                            <button key={index}
                                                onClick={() => {
                                                    generateImageBySuggestionPrompt(suggestion);
                                                    fetchPromptSuggestions(suggestion)
                                                }}
                                                disabled={isImageLoading}
                                                className='w-fit px-[12px] py-[8px] flexCenter text-start gap-[8px] bg-[#FDF8F9] text-[13px] leading-[16px] text-[#1E242C] border border-[#DBDFE5] rounded-[8px]'
                                            >
                                                {suggestion}
                                                <img className='my-[6px] mx-[10px]' src={arrow} alt="arrow" />
                                            </button>
                                        ))
                                    }
                                </div>
                            }
                        </div>

                    </div>
                </div>
            </div>

            <div
                className="absolute bottom-[60px] w-[360px] h-[20px] pointer-events-none"
                style={{
                    boxShadow: '10px 0px 20px 25px rgba(255, 255, 255, 2)',
                }}
            />

            {userData?.showTipsForBestResultsBar && <div style={{ bottom: promptBoxHeight + 30 }} className={`absolute w-full h-[48px] px-[24px] bg-[#F2F5FD]  text-[13px] flex items-center justify-between ${!isOnBoarding && 'z-50'}`}>
                <div className='flex items-center gap-[8px]'>
                    <img src={tipsSvg} alt="tips" />
                    <p className='text-[#1A73E8] leading-[16px] select-none'>Not seeing the results you want? Try refining your prompts by adding themes, key elements, or “specific text”.&nbsp;
                        <span onClick={() => dispatch(setIsTipsForBestResults(true))} className='font-helveticaText-Medium underline underline-offset-4 decoration-1 cursor-pointer select-none'>Take a look</span>
                        &nbsp;at tips on how to best present your idea!
                    </p>
                </div>
                <CloseIconSvg fill="#1A73E8" className="cursor-pointer" onClick={updateShowTipsForBestResultsBar} />
            </div>}

            <TipsForBestResults />

            {/* Prompt Section */}
            <div ref={parentRef} className={`absolute  bottom-0 w-full p-[16px] bg-white min-h-[80px] max-h-[140px] px-[16px] flex  justify-between gap-[16px] border-t ${!isOnBoarding && 'z-50'}  ${isOnBoarding && onBoardingSteps === 2 && 'absolute z-30'} shadow-[0px_-12px_48px_0px_rgba(0,0,0,0.02)]`}>
                <img className='h-[40px] w-[16px] pt-[5px]' src={smartSearchBtnIcon} alt="smart search icon" />
                <div className='w-full flex items-center'>
                    <textarea
                        ref={textareaRef}
                        className="resize-none w-full outline-none bg-transparent text-cus_primary font-helveticaText-Regular text-[16px] leading-[24px] tracking-[-0.02em] placeholder-[#667488] caret-pink-primary"
                        type="text"
                        value={prompt}
                        onChange={(e) => { dispatch(setPrompt(e.target.value)); }}
                        onFocus={() => { setIsTextareaFocused(true); dispatch(setPromptBoxFocus(true)) }}
                        onBlur={handleTextareaBlur}
                        placeholder={placeholder}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                                if (disableGenerateButton) return;
                                e.preventDefault();
                                generateImageHandler();
                                setIsTextareaFocused(false);
                                dispatch(setPromptBoxFocus(false))
                            }
                        }}
                        style={{
                            opacity: isFading ? 0 : 1,
                            transform: isFading ? "translateY(10px)" : "translateY(0)",
                            transition: "opacity 0.7s ease-in-out, transform 0.7s ease-in-out",
                        }}
                    />
                </div>
                {prompt.trim().length !== 0 && <div className='h-[40px] w-[20px] flex items-center justify-center'>
                    <img data-tooltip-id={`eraser`} id="eraser" onClick={() => {
                        dispatch(setPrompt(''));
                        textareaRef.current?.focus();
                        dispatch(setPromptBoxFocus(true))
                        setIsTextareaFocused(true);
                    }} className='h-[16px] w-[16px] cursor-pointer' src={closeIcon} alt="erase" />
                </div>}
                <GenerateButton data-tooltip-id={`generate-visual`} id="generate-visuals" onClick={generateImageHandler} disableGenerateButton={disableGenerateButton} />
            </div>

            {isOnBoarding && onBoardingSteps === 2 && <OnBoardingStep2 />}

            {/* suggested prompt section */}
            {shouldShowBox && (
                <div
                    style={{ bottom: promptBoxHeight + 30 }}
                    className="h-auto w-full px-[48px] py-[16px] absolute z-[97] bg-white flex flex-col gap-[16px] shadow-recent-prompt-top border-t transition-all duration-500 ease-in-out border-b"
                >
                    <img
                        onClick={() => {
                            setIsTextareaFocused(false);
                            dispatch(setPromptBoxFocus(false));
                        }}
                        className="h-[14px] w-[14px] absolute top-4 right-4 cursor-pointer"
                        src={closeIcon}
                        alt="erase"
                    />

                    <p className="text-[#313945] px-[8px] font-helveticaText-Medium font-[500] leading-[24px] tracking-[-0.02em]">
                        {isPromptEmpty ? "Recently used prompt" : "Prompt suggestions"}
                    </p>

                    <div className="w-full max-h-[500px] overflow-y-scroll flex flex-col gap-[8px]">
                        {(isPromptEmpty ? recentlyUsedPrompts : autoCompletePrompts).map((creation, index) => (
                            <div
                                key={index}
                                className="w-full flex items-start gap-[8px] text-start py-[4px] px-[8px] hover:bg-gray-light/30 rounded-[8px] tracking-[-0.02em]"
                            >
                                <img src={isPromptEmpty ? clockIcon : smartSuggestionIcon} alt="" className={`${isPromptEmpty ? 'pt-[5px]' : 'pt-[2px]'}`} />
                                <button
                                    className="w-full text-start"
                                    onClick={(e) => {
                                        dispatch(setPrompt(creation));
                                        e.stopPropagation();
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: getHighlightedMatch(creation, prompt),
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <ModalsWrapper
                open={openTermsAndConditions && urlMd5}
                onClose={() => {
                    if (urlMd5) {
                        updateUserDataHandler(false)
                        ReactGA.gtag('event', 'terms_and_conditions_decline', {
                            action: 'Terms and Conditions declined',
                            label: 'Terms and Conditions declined'
                        });
                    };
                    dispatch(setTermsAndConditions(false));
                }} >
                <TermandConditions
                    handleAccept={() => {
                        updateUserDataHandler(true);
                        dispatch(setTermsAndConditions(false))
                        generateImageHandleTandCAccept()
                        // setIsOnBoarding(true)
                    }}
                    handleDecline={() => {
                        updateUserDataHandler(false);
                        dispatch(setCheckTermsAndConditions(true))
                        navigate('/generate-image');
                        dispatch(setTermsAndConditions(false));
                        dispatch(setIsVisualizePageVisible(true));

                        ReactGA.gtag('event', 'terms_and_conditions_decline', {
                            action: 'Terms and Conditions declined',
                            label: 'Terms and Conditions declined'
                        });
                    }} />
            </ModalsWrapper>

            <ModalsWrapper open={openNpsFeedback} onClose={() => setOpenNpsFeedback(false)}>
                <NpsFeedback onClose={() => setOpenNpsFeedback(false)} />
            </ModalsWrapper>

            <Tooltip id={`generate-visual`} place="bottom" content={tooltipContent} />
            <Tooltip id={`create-new-visual`} place="bottom" content={isImageLoading ? 'Generating visual...' : 'Generate a new visual'} />
            <Tooltip id={`eraser`} place="top" content="Erase" />

        </MainWrapper >
    )
}

export default CreateImages